import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const matchingRulesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_DEFAULT_RULES_SUCCESS: {
            return {
                ...state,
                defaultRules: action.payload,
                defaultRulesForSelectionBox: _map(action.payload, (item) => ({
                    label: item.rule_name,
                    value: item.rule_name,
                })),
            };
        }
        case actionTypes.GET_APPLICATION_RULE_SUCCESS:
            return {
                ...state,
                applicationRuleNames: action.payload,
                applicationRulesNamesForSelectionBox: _map(action.payload, (item) => ({
                    label: item.rule_name,
                    value: item.rule_name,
                })),
            };

        case actionTypes.GET_MATCHING_MAPPING_SUCCESS:
            return {
                ...state,
                matchingMappings: action.payload,
            };
        case actionTypes.GET_PREDICTED_RULE:
            return {
                ...state,
                predictedRule: action.payload,
            };

        case actionTypes.GET_PREDICTED_RULE:
            return {
                ...state,
                predictedRule: action.payload,
            };

        default:
            return state;
    }
};

export default matchingRulesReducer;
